import { useState, useEffect, useRef, useCallback } from 'react';

const CHECK_INTERVAL = 60 * 1000;
const RELOAD_DELAY = 3;

export const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [countdown, setCountdown] = useState(RELOAD_DELAY);
  const initialVersion = useRef(null);
  const timerRef = useRef(null);

  const fetchVersion = useCallback(async () => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
      if (!res.ok) return;
      const data = await res.json();
      const version = data.version;

      if (!initialVersion.current) {
        initialVersion.current = version;
        return;
      }

      if (version !== initialVersion.current) {
        clearInterval(timerRef.current);
        setUpdateAvailable(true);
      }
    } catch {
      // network errors, missing file during dev, etc.
    }
  }, []);

  useEffect(() => {
    fetchVersion();
    timerRef.current = setInterval(fetchVersion, CHECK_INTERVAL);
    return () => clearInterval(timerRef.current);
  }, [fetchVersion]);

  useEffect(() => {
    if (!updateAvailable) return;
    setCountdown(RELOAD_DELAY);
    const id = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(id);
          window.location.reload();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [updateAvailable]);

  return { updateAvailable, countdown };
};
